module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-agreement-checkbox-div"
  }, [_c('input', {
    staticClass: "register-agreement-checkbox",
    attrs: {
      "type": "checkbox",
      "id": "register"
    },
    domProps: {
      "checked": _vm.agreed
    },
    on: {
      "click": _vm.agreementClicked
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "register-agreement-label",
    attrs: {
      "for": "register"
    }
  }, [_vm._v(" 同意")]), _vm._v(" "), _c('a', {
    staticClass: "register-agreement-a",
    attrs: {
      "target": "_blank",
      "href": "http://reg.lingxi360.com/register/agreement"
    }
  }, [_vm._v("《灵析用户注册/使用条款》")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-48870b8b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-48870b8b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/common/RegisterAgreement.vue
// module id = 847
// module chunks = 0